import {
  omit,
  pick,
  sortBy,
} from 'lodash';

import {
  createOptions,
  monthsOptions,
  otherOption,
} from '@/helpers/common';
import * as commonConstants from '@/constants/common';
import * as carConstants from '@/constants/products/car';

// icons
import IconWheelLeft from '!svg-inline-loader!@/assets/icons/icon-wheel-left.svg';
import IconWheelRight from '!svg-inline-loader!@/assets/icons/icon-wheel-right.svg';
import IconHome from '!svg-inline-loader!@/assets/icons/icon-home.svg';

const constants = Object.assign(
  {},
  commonConstants,
  carConstants,
);

export default (stepNumber) => {
  const commonOptions = {
    noYes: constants.NO_YES,
    yesNo: constants.NO_YES.slice().reverse(),
    attrsForNumKeyboard: constants.ATTRS_FOR_NUM_KEYBOARD,
  };

  switch (stepNumber) {
    case 1:
      return {
        ...commonOptions,
        months: monthsOptions,
        vehicleSide: [
          {
            value: true,
            text: 'Left',
            icon: IconWheelLeft,
            iconType: 'component',
          },
          {
            value: false,
            text: 'Right',
            icon: IconWheelRight,
            iconType: 'component',
          },
        ],
        vehicleSeatsQty: createOptions({ source: constants.VEHICLE_SEATS_QTY }),
        vehicleGreyOrImport: createOptions({ source: omit(constants.VEHICLE_GREY_OR_IMPORT, ['N']) }),
        vehicleAlarm: createOptions({ source: omit(constants.VEHICLE_ALARM_IMMOBILISER, ['N']) }),
        vehicleTypeOfUseGenericOptions: [
          ...createOptions({
            source: pick(constants.VEHICLE_TYPE_OF_USE, constants.VEHICLE_TYPE_OF_USE_FAVORITES),
            asNumbers: true,
          }),
          {
            value: true,
            text: constants.VEHICLE_TYPE_OF_USE_OTHER,
            logical: true,
            logicalValue: '',
          },
        ],
        vehicleTypeOfUseBusinessOptions: createOptions({
          source: omit(constants.VEHICLE_TYPE_OF_USE, constants.VEHICLE_TYPE_OF_USE_FAVORITES),
          asNumbers: true,
        }),
        vehicleOwnerOfVehicle: createOptions({
          source: constants.COVER_OWNER_OF_VEHICLE,
          asNumbers: true,
        })
          .sort(({ text }) => text === 'Other' ? 1 : 0),
        vehicleRegisteredOfVehicle: createOptions({
          source: constants.COVER_REGISTERED_OF_VEHICLE,
          asNumbers: true,
        })
          .sort(({ text }) => text === 'Other' ? 1 : 0),
        vehicleKeptGeneric: [
          ...createOptions({ source: pick(constants.VEHICLE_KEPT, constants.VEHICLE_KEPT_FAVORITES) }),
          otherOption(),
        ],
        vehicleKeptOther: createOptions({ source: omit(constants.VEHICLE_KEPT, constants.VEHICLE_KEPT_FAVORITES) }),
        vehicleKeptDayGeneric: [
          ...createOptions({ source: pick(constants.VEHICLE_KEPT_DAY, constants.VEHICLE_KEPT_DAY_FAVORITES) }),
          otherOption(),
        ],
        vehicleKeptDayOther: createOptions({ source: omit(constants.VEHICLE_KEPT_DAY, constants.VEHICLE_KEPT_DAY_FAVORITES) }),
      };
    case 2:
      return {
        ...commonOptions,
        months: monthsOptions,
        IconHome,
        driverTitles: createOptions({ source: constants.TITLES }),
        driverMaritalStatusGeneric: [
          ...createOptions({ source: pick(constants.DRIVER_MARITAL_STATUS, constants.DRIVER_MARITAL_STATUS_FAVORITES) }),
          otherOption(),
        ],
        driverMaritalStatusOther: createOptions({ source: omit(constants.DRIVER_MARITAL_STATUS, constants.DRIVER_MARITAL_STATUS_FAVORITES) }),
        driverResidentialStatus: createOptions({ source: constants.DRIVER_RESIDENTIAL_STATUS }),
        driverEmploymentStatusGeneric: [
          ...createOptions({ source: pick(constants.DRIVER_EMPLOYMENT_STATUS, constants.DRIVER_EMPLOYMENT_STATUS_FAVORITES) }),
          otherOption(),
        ],
        driverEmploymentStatusOther: createOptions({ source: omit(constants.DRIVER_EMPLOYMENT_STATUS, constants.DRIVER_EMPLOYMENT_STATUS_FAVORITES) }),
        driverTypeOfDrivingGeneric: [
          ...createOptions({ source: pick(constants.DRIVER_TYPE_OF_DRIVING, constants.DRIVER_TYPE_OF_DRIVING_FAVORITES) }),
          otherOption(),
        ],
        driverTypeOfDrivingOther: createOptions({ source: omit(constants.DRIVER_TYPE_OF_DRIVING, constants.DRIVER_TYPE_OF_DRIVING_FAVORITES) }),
        driverLicenceYearsHeld: createOptions({
          source: constants.DRIVER_LICENCE_YEARS_HELD,
          asNumbers: true,
        }),
        driverLicenceMonthsHeld: createOptions({
          source: constants.DRIVER_LICENCE_MONTHS_HELD,
          asNumbers: true,
        }),
        medicalConditions: createOptions({ source: omit(constants.DRIVER_MEDICAL_CONDITIONS, ['N']) }),
        causeOfDescriptionGeneric: [
          ...createOptions({ source: pick(constants.DRIVER_CLAIM_CAUSE_OF_DESCRIPTION, constants.DRIVER_CLAIM_CAUSE_OF_DESCRIPTION_FAVORITES) }),
          otherOption(),
        ],
        causeOfDescriptionOther: createOptions({ source: omit(constants.DRIVER_CLAIM_CAUSE_OF_DESCRIPTION, constants.DRIVER_CLAIM_CAUSE_OF_DESCRIPTION_FAVORITES) }),
        atFault: createOptions({ source: constants.DRIVER_CLAIM_AT_FAULT }),
        typeTheft: createOptions({ source: constants.DRIVER_CLAIM_TYPE_THEFT }),
        alcoholMethodTest: createOptions({ source: constants.DRIVER_CONVICTION_ALCOHOL_METHOD_TEST }),
        pointsReceived: createOptions({
          source: constants.DRIVER_CONVICTION_POINTS_RECEIVED,
          asNumbers: true,
        }),
        relationshipProposerGeneric: [
          ...createOptions({ source: pick(constants.DRIVER_ADDITIONAL_RELATIONSHIP_PROPOSER, constants.DRIVER_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES) }),
          otherOption(),
        ],
        relationshipProposerOther: createOptions({ source: omit(constants.DRIVER_ADDITIONAL_RELATIONSHIP_PROPOSER, constants.DRIVER_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES) }),
        useOfOtherVehicles: createOptions({ source: constants.COVER_USE_OF_OTHER_VEHICLES }),
        childrenGeneric: [
          ...createOptions({
            source: pick(constants.DRIVER_CHILDREN, constants.DRIVER_CHILDREN_FAVORITES),
            asNumbers: true,
          }),
          {
            ...otherOption(),
            text: constants.DRIVER_CHILDREN_MORE_LABEL,
          },
        ],
        childrenOther: createOptions({
          source: omit(constants.DRIVER_CHILDREN, constants.DRIVER_CHILDREN_FAVORITES),
          asNumbers: true,
        }),
      };
    case 3:
      return {
        ...commonOptions,
        typeOfCover: createOptions({
          source: constants.COVER_TYPE_OF_COVER,
          asNumbers: true,
        }).map(item => ({
          ...item,
          helpText: constants.COVER_TYPE_OF_COVER_DESCRIPTION[item.value],
        })),
        voluntaryExcess: sortBy(createOptions({
          source: constants.COVER_VOLUNTARY_EXCESS,
          asNumbers: true,
        }), ['value']).reverse(),
        noClaimsBonus: createOptions({
          source: constants.COVER_NO_CLAIMS_BONUS,
          asNumbers: true,
        }),
        typeExperience: createOptions({ source: constants.COVER_TYPE_EXPERIENCE }),
        freeDriving: createOptions({
          source: constants.COVER_FREE_DRIVING,
          asNumbers: true,
        }),
        useOfOtherVehicles: createOptions({ source: constants.COVER_USE_OF_OTHER_VEHICLES }),
        numberOfOtherVehiclesGeneric: [
          ...createOptions({
            source: pick(constants.COVER_NUMBER_OF_OTHER_VEHICLES, constants.COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES),
            asNumbers: true,
          }),
          otherOption(),
        ],
        numberOfOtherVehiclesOther: createOptions({
          source: omit(constants.COVER_NUMBER_OF_OTHER_VEHICLES, constants.COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES),
          asNumbers: true,
        }),
        hearAboutUs: createOptions({
          source: constants.HEAR_ABOUT_US,
          asNumbers: true,
        }),
      };
  }
};
